export type Side = 'top' | 'bottom' | 'left' | 'right';
export type Align = 'start' | 'center' | 'end';

const MARGIN = 8;
const OPPOSITE: Record<Side, Side> = { top: 'bottom', bottom: 'top', left: 'right', right: 'left' };

/** Fixed-position coordinates for a floating element next to an anchor, flipped/clamped to the viewport. */
export function computePosition(
  anchor: DOMRect,
  size: { width: number; height: number },
  side: Side,
  align: Align,
  offset = 8,
): { top: number; left: number; side: Side } {
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  const fits = (s: Side): boolean => {
    switch (s) {
      case 'bottom':
        return anchor.bottom + offset + size.height <= vh - MARGIN;
      case 'top':
        return anchor.top - offset - size.height >= MARGIN;
      case 'right':
        return anchor.right + offset + size.width <= vw - MARGIN;
      case 'left':
        return anchor.left - offset - size.width >= MARGIN;
    }
  };
  const chosen = !fits(side) && fits(OPPOSITE[side]) ? OPPOSITE[side] : side;

  let top: number;
  let left: number;
  if (chosen === 'top' || chosen === 'bottom') {
    top = chosen === 'bottom' ? anchor.bottom + offset : anchor.top - offset - size.height;
    left =
      align === 'start' ? anchor.left : align === 'end' ? anchor.right - size.width : anchor.left + anchor.width / 2 - size.width / 2;
  } else {
    left = chosen === 'right' ? anchor.right + offset : anchor.left - offset - size.width;
    top =
      align === 'start' ? anchor.top : align === 'end' ? anchor.bottom - size.height : anchor.top + anchor.height / 2 - size.height / 2;
  }
  left = Math.max(MARGIN, Math.min(left, vw - size.width - MARGIN));
  top = Math.max(MARGIN, Math.min(top, vh - size.height - MARGIN));
  return { top: Math.round(top), left: Math.round(left), side: chosen };
}
